module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "uploads__list unfinished-uploads__list"
  }, [_c('button', {
    staticClass: "button hide",
    on: {
      "click": _vm.onHideClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "unfinished-uploads__title"
  }, [_vm._v("Unfinished uploads list")]), _vm._v(" "), _c('p', {
    staticClass: "unfinished-uploads__info"
  }, [_vm._v("\n    You have unfinished uploads.\n    Probably, your browser was crashed or you're closed the page during file uploading.\n    Please, select file to continue upload or remove them from the list.\n  ")]), _vm._v(" "), (_vm.unfinishedUploads.length) ? _vm._l((_vm.unfinishedUploads), function(unfinishedItem) {
    return _c('ListItem', {
      key: unfinishedItem.id,
      attrs: {
        "filename": unfinishedItem.filename,
        "accepted-files": unfinishedItem.uploadParams.acceptedFiles || ''
      },
      on: {
        "file-selected": function($event) {
          return _vm.onFileSelected($event, unfinishedItem)
        },
        "remove-clicked": function($event) {
          return _vm.onRemoveClicked($event, unfinishedItem.id)
        }
      }
    })
  }) : _c('p', {
    staticClass: "unfinished-uploads__resolved"
  }, [_vm._v("All unfinished uploads are resolved.")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b716f98","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadManager/UnfinishedList.vue
// module id = 888
// module chunks = 0